/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { TranslatorContext } from '@jutro/locale';
import metadata from './AdjacentStructionsComponent.metadata.json5';
import styles from './AdjacentStructionsComponent.module.scss';

function AdjacentStructionsComponent(props) {

    const {
        data: AdjacentStructionsVM,
        updateWizardData,
        submissionVM
    } = props;

    _.each(AdjacentStructionsVM.value, (v) => {
        v.isValidationReq = true
    });

    const translator = useContext(TranslatorContext);

    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;


            if (path === 'dirFie') {
                const directionLabels = ['North', 'East', 'South', 'West'];
                const value = directionLabels[index] || '';

                return (
                    <div className={styles.tableColumn}>
                        {value}
                    </div>
                );
            }


            if (path === 'typofConFie') {
                const value = (item && item.typofConFie) ? item.typofConFie : undefined;

                const availableValues = AdjacentStructionsVM.length > 0 && AdjacentStructionsVM.children[index].typofConFie
                    ? AdjacentStructionsVM.children[index].typofConFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.typofConFie = val.code;
                            handleValueChange(val, changedPath, index);
                        }}
                        path={path}
                        dataType="String"
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'occFie') {
                const value = (item && item.occFie) ? item.occFie : undefined;

                const availableValues = AdjacentStructionsVM.length > 0 && AdjacentStructionsVM.children[index].occFie
                    ? AdjacentStructionsVM.children[index].occFie.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.occFie = val.code;
                            handleValueChange(val, changedPath, index);
                        }}
                        path={path}
                        dataType="String"
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'disFeeFie') {
                const value = item.disFeeFie;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="Number"
                        onValueChange={(val, changedPath) => {
                            item.disFeeFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'ifothexpFie' && item.typofConFie !== undefined && item.typofConFie === 'Other') {
                const value = item.ifothexpFie ? item.ifothexpFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.ifothexpFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [AdjacentStructionsVM, handleValueChange, translator])

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`AdjacentStructionsTable`]: {
            data: AdjacentStructionsVM?.value,
        }

    }), [AdjacentStructionsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            getTableCell
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            AdjacentStructionsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [AdjacentStructionsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={AdjacentStructionsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AdjacentStructionsComponent.propTypes = wizardProps;
export default withRouter(AdjacentStructionsComponent);
